//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.5.0.0 (NJsonSchema v10.1.15.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseConfiguration } from './base-configuration.service';
import { Router } from '@angular/router';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ServiceBase  {

    private _snackBar: MatSnackBar;
    private _router: Router;

    constructor() {
        const baseConfiguration = inject(BaseConfiguration);

        this._snackBar = baseConfiguration.getSnackBar();
        this._router = baseConfiguration.getRouter();
    }

    protected transformOptions(options: any) {
        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: HttpResponse<Blob>, processor: (response: HttpResponse<Blob>) => any): Observable<any> {
        return processor(response);
    }
}

@Injectable()
export class Client extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        const http = inject<HttpClient>(HttpClient);
        const baseUrl = inject(API_BASE_URL, { optional: true });

        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://atar-student-service.prod.qtac.edu.au";
    }

    /**
     * @return default response
     */
    get(): Observable<StudentProfileResponse> {
        let url_ = this.baseUrl + "/student/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StudentProfileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentProfileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StudentProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentProfileResponse>(<any>null);
    }

    /**
     * @return default response
     */
    update(body: UpdateStudentRequest): Observable<RegisteredStudent> {
        let url_ = this.baseUrl + "/student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredStudent>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredStudent>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegisteredStudent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisteredStudent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredStudent>(<any>null);
    }

    /**
     * @return default response
     */
    updateEmail(body: UpdateStudentEmailRequest): Observable<UpdateStudentEmailResponse> {
        let url_ = this.baseUrl + "/student/update-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudentEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudentEmail(<any>response_);
                } catch (e) {
                    return <Observable<UpdateStudentEmailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateStudentEmailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStudentEmail(response: HttpResponseBase): Observable<UpdateStudentEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateStudentEmailResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStudentEmailResponse>(<any>null);
    }

    /**
     * @param exitYear
     * @return default response
     */
    getCertificatePdf(exitYear: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/student/me/pdf/{exitYear}";
        if (exitYear === undefined || exitYear === null)
            throw new Error("The parameter 'exitYear' must be defined.");
        url_ = url_.replace("{exitYear}", encodeURIComponent("" + exitYear));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificatePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificatePdf(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificatePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }


    /**
     * @return default response
     */
    logout(): Observable<SignoutReponse> {
        let url_ = this.baseUrl + "/user/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<SignoutReponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignoutReponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<SignoutReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignoutReponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignoutReponse>(<any>null);
    }

    /**
     * @return default response
     */
    signUp(body: SignupRequest): Observable<SignupResponse> {
        let url_ = this.baseUrl + "/user/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignUp(<any>response_);
                } catch (e) {
                    return <Observable<SignupResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignupResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSignUp(response: HttpResponseBase): Observable<SignupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupResponse>(<any>null);
    }

    /**
     * @return default response
     */
    forgotPassword(body: PasswordRequest): Observable<PasswordResponse> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(<any>response_);
                } catch (e) {
                    return <Observable<PasswordResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PasswordResponse>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<PasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PasswordResponse>(<any>null);
    }

    /**
     * @return default response
     */
    confirmSignUp(body: ConfirmSignupRequest): Observable<SignupResponse> {
        let url_ = this.baseUrl + "/user/confirm-signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSignUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSignUp(<any>response_);
                } catch (e) {
                    return <Observable<SignupResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignupResponse>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmSignUp(response: HttpResponseBase): Observable<SignupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupResponse>(<any>null);
    }

    /**
     * @return default response
     */
    verifyEmail(body: VerifyEmailRequest): Observable<SignupResponse> {
        let url_ = this.baseUrl + "/user/verify-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmail(<any>response_);
                } catch (e) {
                    return <Observable<SignupResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignupResponse>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyEmail(response: HttpResponseBase): Observable<SignupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SignupResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupResponse>(<any>null);
    }

    /**
     * @return default response
     */
    resendCode(body: ResendCodeRequest): Observable<SignupResponse> {
        let url_ = this.baseUrl + "/user/resend-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendCode(<any>response_);
                } catch (e) {
                    return <Observable<SignupResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignupResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResendCode(response: HttpResponseBase): Observable<SignupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupResponse>(<any>null);
    }

    /**
     * @return default response
     */
    resendConfirmedCode(body: ResendConfirmedCodeRequest): Observable<SignupResponse> {
        let url_ = this.baseUrl + "/user/resend-confirmed-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendConfirmedCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmedCode(<any>response_);
                } catch (e) {
                    return <Observable<SignupResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignupResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResendConfirmedCode(response: HttpResponseBase): Observable<SignupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SignupResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupResponse>(<any>null);
    }

    /**
     * @return default response
     */
    resetPassword(body: PasswordRequest): Observable<PasswordResponse> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<PasswordResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PasswordResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<PasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PasswordResponse>(<any>null);
    }

    /**
     * @return default response
     */
    login(body: AuthenticationRequest): Observable<AuthenticationResponse> {
        let url_ = this.baseUrl + "/user/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AuthenticationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticationResponse>(<any>null);
    }


    /**
     * @param verificationToken (required)
     * @return default response
     */
    getCertificateVerification(verificationToken: string): Observable<CertificateVerificationResponse> {
        let url_ = this.baseUrl + "/verify/{verificationToken}";
        if (verificationToken === undefined || verificationToken === null)
            throw new Error("The parameter 'verificationToken' must be defined.");
        url_ = url_.replace("{verificationToken}", encodeURIComponent("" + verificationToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateVerification(<any>response_);
                } catch (e) {
                    return <Observable<CertificateVerificationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateVerificationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateVerification(response: HttpResponseBase): Observable<CertificateVerificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateVerificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateVerificationResponse>(<any>null);
    }
}

export class CertificateVerificationResponse {
    code?: string;
    exitYear?: number;
    score?: string;  // Backend returns formatted string e.g. "85.50" or "30 or less"
    issueDate?: string;
    amended?: boolean;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.exitYear = _data["exitYear"];
            this.score = _data["score"];
            this.issueDate = _data["issueDate"];
            this.amended = _data["amended"];
        }
    }

    static fromJS(data: any): CertificateVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["exitYear"] = this.exitYear;
        data["score"] = this.score;
        data["issueDate"] = this.issueDate;
        data["amended"] = this.amended;
        return data;
    }
}

export class AtarScore {
    exitYear!: number;
    score!: string;
    releaseDate!: Date;

    init(_data?: any) {
        if (_data) {
            this.exitYear = _data["exitYear"];
            this.score = _data["score"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AtarScore {
        data = typeof data === 'object' ? data : {};
        let result = new AtarScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exitYear"] = this.exitYear;
        data["score"] = this.score;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        return data;
    }
}

export class RegisteredStudent {
  id?: string;
  lui?: string;
  email!: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  phone?: string;
  shareDataWithSchool!: boolean;
  receiveResultsByEmail!: boolean;
  customerDeclarationConsentVersion?: number;
  shareDataWithSchoolConsentVersion?: number;
  receiveResultsByEmailConsentVersion?: number;
  researchAndAnalysisConsentVersion?: number;
  redoConsents: boolean = false;
  hasPaidForCertificate: boolean = false;
  certificatePaymentDate?: string;

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.lui = _data['lui'];
      this.email = _data['email'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.dateOfBirth = _data['dateOfBirth'];
      this.phone = _data['phone'];
      this.shareDataWithSchool = _data['shareDataWithSchool'];
      this.receiveResultsByEmail = _data['receiveResultsByEmail'];
      this.customerDeclarationConsentVersion = _data['customerDeclarationConsentVersion'];
      this.shareDataWithSchoolConsentVersion = _data['shareDataWithSchoolConsentVersion'];
      this.receiveResultsByEmailConsentVersion = _data['receiveResultsByEmailConsentVersion'];
      this.researchAndAnalysisConsentVersion = _data['researchAndAnalysisConsentVersion'];
      this.redoConsents = _data['redoConsents'];
      this.hasPaidForCertificate = _data['hasPaidForCertificate'];
      this.certificatePaymentDate = _data['certificatePaymentDate'];
    }
  }

  static fromJS(data: any): RegisteredStudent {
    data = typeof data === 'object' ? data : {};
    let result = new RegisteredStudent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['lui'] = this.lui;
    data['email'] = this.email;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['dateOfBirth'] = this.dateOfBirth;
    data['phone'] = this.phone;
    data['shareDataWithSchool'] = this.shareDataWithSchool;
    data['receiveResultsByEmail'] = this.receiveResultsByEmail;
    data['customerDeclarationConsentVersion'] = this.customerDeclarationConsentVersion;
    data['shareDataWithSchoolConsentVersion'] = this.shareDataWithSchoolConsentVersion;
    data['receiveResultsByEmailConsentVersion'] = this.receiveResultsByEmailConsentVersion;
    data['researchAndAnalysisConsentVersion'] = this.researchAndAnalysisConsentVersion;
    data['redoConsents'] = this.redoConsents;
    data['hasPaidForCertificate'] = this.hasPaidForCertificate;
    data['certificatePaymentDate'] = this.certificatePaymentDate;
    return data;
  }
}

export class StudentProfileResponse {
    personalDetails!: RegisteredStudent;
    atarScores!: AtarScore[];

    init(_data?: any) {
        if (_data) {
            this.personalDetails = _data["personalDetails"] ? RegisteredStudent.fromJS(_data["personalDetails"]) : new RegisteredStudent();
            if (Array.isArray(_data["atarScores"])) {
                this.atarScores = [] as any;
                for (let item of _data["atarScores"])
                    this.atarScores!.push(AtarScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StudentProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.atarScores)) {
            data["atarScores"] = [];
            for (let item of this.atarScores)
                data["atarScores"].push(item.toJSON());
        }
        return data;
    }
}

export class UpdateStudentRequest {
    lui?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
    phone?: string;
    shareDataWithSchool?: boolean;
    receiveResultsByEmail?: boolean;
    researchAndAnalysisConsentAccepted?: boolean;

    init(_data?: any) {
        if (_data) {
            this.lui = _data["lui"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.phone = _data["phone"];
            this.shareDataWithSchool = _data["shareDataWithSchool"];
            this.receiveResultsByEmail = _data["receiveResultsByEmail"];
            this.researchAndAnalysisConsentAccepted = _data["researchAndAnalysisConsentAccepted"];
        }
    }

    static fromJS(data: any): UpdateStudentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lui"] = this.lui;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["phone"] = this.phone;
        data["shareDataWithSchool"] = this.shareDataWithSchool;
        data["receiveResultsByEmail"] = this.receiveResultsByEmail;
        data["researchAndAnalysisConsentAccepted"] = this.researchAndAnalysisConsentAccepted;
        return data;
    }
}

export class UpdateStudentEmailRequest {
    email!: string;
    newEmail!: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): UpdateStudentEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["newEmail"] = this.newEmail;
        return data;
    }
}

export class UpdateStudentEmailResponse {
    message!: string;
    email!: string;

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateStudentEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["email"] = this.email;
        return data;
    }
}

export class SignoutReponse {
    message?: string;

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SignoutReponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignoutReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export class SignupRequest {
    username?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SignupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export class SignupResponse {
    message?: string;
    destination?: string;
    deliveryMedium?: string;

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.destination = _data["destination"];
            this.deliveryMedium = _data["deliveryMedium"];
        }
    }

    static fromJS(data: any): SignupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["destination"] = this.destination;
        data["deliveryMedium"] = this.deliveryMedium;
        return data;
    }
}

export class PasswordRequest {
    username!: string;
    password?: string;
    confirmationCode?: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): PasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export class PasswordResponse {
    message?: string;
    destination?: string;
    deliveryMedium?: string;

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.destination = _data["destination"];
            this.deliveryMedium = _data["deliveryMedium"];
        }
    }

    static fromJS(data: any): PasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["destination"] = this.destination;
        data["deliveryMedium"] = this.deliveryMedium;
        return data;
    }
}

export class ConfirmSignupRequest {
    email!: string;
    confirmationCode?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ConfirmSignupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSignupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export class VerifyEmailRequest {
    email!: string;
    confirmationCode?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): VerifyEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export class ResendCodeRequest {
    username!: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ResendCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export class ResendConfirmedCodeRequest {
    username!: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ResendCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export class AuthenticationRequest {
    username?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export class AuthenticationResponse {
    idToken?: string;
    accessToken?: string;
    refreshToken?: string;
    expiresIn?: number;

    init(_data?: any) {
        if (_data) {
            this.idToken = _data["idToken"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): AuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idToken"] = this.idToken;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
